import { View } from "../View";

export default class Q4_2 extends View {
    render() {
        return (
            <div className="Q4_2">
                <h2>Vous commencez à m'apprécier...</h2>
                <hr />
                <div className="btn-group">
                    <button onClick={ () => this.props.onFinish() }>Ok</button>
                </div>
            </div>
        );
    }
}
